import React, { useEffect, useState } from "react";
import config from "../config";
import { AiOutlineDelete, AiOutlineEdit } from "react-icons/ai";
import { IoIosAdd } from "react-icons/io";

export default function Usermanagement() {
  const initialUserData = {
    username: "",
    password: "",
    role: "",
  };

  const [userFormData, setUserFormData] = useState(initialUserData);
  const [usersData, setUsersData] = useState([]);

  const [recordToDelete, setRecordToDelete] = useState(null);
  const [recordToEdit, setRecordToEdit] = useState(null);

  const [responseMessage, setResponseMessage] = useState("");
  const [showResponse, setShowResponse] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showError, setShowError] = useState(false);

  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const clearForm = () => {
    setUserFormData(initialUserData);
  };

  // fetching users for listing
  const fetchUsers = async () => {
    if (!hasMore) return;

    setIsLoading(true);

    try {
      const response = await fetch(
        `${config.apiUrl}lazyLoad.php?option=4&subcategory=0&page=${page}`
      );
      const fetchUsersData = await response.json();

      // Extract the list of contents from the API response
      const newUsers = fetchUsersData.map((item) => ({
        username: item.username,
        role: item.role,
        id: item.id,
        password: item.password,
      }));

      setUsersData([...usersData, ...newUsers]);
      setPage(page + 1);
      setHasMore(newUsers.length > 0);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const loadMore = () => {
    fetchUsers();
  };

  useEffect(() => {
    fetchUsers(); // Initial data fetch
  }, []);

  // TODO: change the bellow code from scroll to click
  useEffect(() => {
    window.addEventListener("scroll", loadMore);

    return () => {
      window.removeEventListener("scroll", loadMore);
    };
  }, [page]);

  // Create new user
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(`${config.apiUrl}adminapi.php?option=2`, {
        method: "POST",
        body: JSON.stringify(userFormData),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();

      if (response.ok) {
        setShowResponse(true);
        setResponseMessage("User created successfully.");

        const newUser = {
          username: userFormData.username,
          role: userFormData.role,
          id: data.id,
        };

        setUsersData([...usersData, newUser]);

        setTimeout(() => {
          setShowResponse(false);
          setResponseMessage("");
        }, 5000);

        clearForm();
      }
    } catch (error) {
      console.error("Error creating user:", error);
      setShowError(true);
      setErrorMessage("An error occurred while creating the user.");

      setTimeout(() => {
        setShowError(false);
        setErrorMessage("");
      }, 5000);
    }
  };

  const handleDelete = (user) => {
    setRecordToDelete(user.id);
  };

  // Delete user
  const confirmDelete = async () => {
    try {
      const response = await fetch(`${config.apiUrl}adminapi.php?option=5`, {
        method: "POST",
        body: JSON.stringify({ userId: recordToDelete }),
        credentials: "include",
      });

      if (response.ok) {
        const updatedList = usersData.filter(
          (item) => item.id !== recordToDelete
        );

        setUsersData(updatedList);
        setRecordToDelete(null);

        setShowResponse(true);
        setResponseMessage("User deleted successfully.");

        setTimeout(() => {
          setShowResponse(false);
          setResponseMessage("");
        }, 5000);
      } else {
        setShowError(true);
        setErrorMessage("An error occurred while deleting the user.");

        setTimeout(() => {
          setShowError(false);
          setErrorMessage("");
        }, 5000);
      }
    } catch (error) {
      console.error("Error deleting user:", error);
      setShowError(true);
      setErrorMessage("Failed to delete user.");

      setTimeout(() => {
        setShowError(false);
        setErrorMessage("");
      }, 5000);
    }
  };

  const handleEdit = (user) => {
    setRecordToEdit(user);
  };

  const saveEditedRecord = async () => {
    try {
      const response = await fetch(`${config.apiUrl}adminapi.php?option=6`, {
        method: "POST",
        body: JSON.stringify(recordToEdit),
        credentials: "include",
      });

      if (response.ok) {
        const updatedList = usersData.map((item) =>
          item.id === recordToEdit.id ? recordToEdit : item
        );

        setUsersData(updatedList);
        setRecordToEdit(null);

        setShowResponse(true);
        setResponseMessage("User updated successfully.");

        setTimeout(() => {
          setShowResponse(false);
          setResponseMessage("");
        }, 5000);
      } else {
        setShowError(true);
        setErrorMessage("An error occurred while updating the user.");

        setTimeout(() => {
          setShowError(false);
          setErrorMessage("");
        }, 5000);
      }
    } catch (error) {
      console.error("Error updating user:", error);
      setShowError(true);
      setErrorMessage("Failed to update user.");

      setTimeout(() => {
        setShowError(false);
        setErrorMessage("");
      }, 5000);
    }
  };

  const usersList = usersData.map((item, index) => (
    <tr key={item.id}>
      <td>{index + 1}</td>
      <td>
        <p
          className="d-inline-block text-truncate"
          style={{ maxWidth: "300px" }}
        >
          {item.username}
        </p>
      </td>
      <td>{item.role}</td>
      <td>
        <button
          type="button"
          className="btn btn-sm btn-warning rounded me-1"
          onClick={() => handleEdit(item)}
          data-bs-toggle="modal"
          data-bs-target="#userEditModal"
        >
          <AiOutlineEdit />
        </button>
        <div
          className="modal fade"
          id="userEditModal"
          tabIndex="-1"
          aria-labelledby="userEditModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-md">
            <div className="modal-content">
              <div className="modal-header" dir="rtl">
                <h1 className="modal-title fs-5" id="userEditModalLabel">
                  ویرایش ریکارد یوزر
                </h1>
              </div>
              <div className="modal-body">
                <form>
                  <div className="form-group row g-3">
                    <div>
                      <label htmlFor="usernameEdit" className="form-label">
                        Username
                      </label>
                      <input
                        type="text"
                        dir="ltr"
                        className="form-control"
                        id="usernameEdit"
                        name="username"
                        placeholder="Enter new username"
                        value={recordToEdit ? recordToEdit.username : ""}
                        onChange={(e) =>
                          setRecordToEdit({
                            ...recordToEdit,
                            username: e.target.value,
                          })
                        }
                        required
                      />
                    </div>
                    <div className="">
                      <label htmlFor="passwordEdit" className="form-label">
                        Password
                      </label>
                      <input
                        type="password"
                        dir="ltr"
                        className="form-control"
                        id="passwordEdit"
                        name="password"
                        placeholder="Enter new password"
                        value={recordToEdit ? recordToEdit.password : ""}
                        onChange={(e) =>
                          setRecordToEdit({
                            ...recordToEdit,
                            password: e.target.value,
                          })
                        }
                        required
                      />
                    </div>
                    <div>
                      <label htmlFor="roleEdit" className="form-label">
                        Role
                      </label>
                      <select
                        dir="ltr"
                        id="roleEdit"
                        required
                        name="role"
                        className="form-select"
                        value={recordToEdit ? recordToEdit.role : ""}
                        onChange={(e) =>
                          setRecordToEdit({
                            ...recordToEdit,
                            role: e.target.value,
                          })
                        }
                      >
                        <option>Select a role</option>
                        <option value="admin">admin</option>
                        <option value="uploader">uploader</option>
                      </select>
                    </div>
                  </div>
                </form>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  لغو
                </button>
                <button
                  type="button"
                  onClick={saveEditedRecord}
                  className="btn btn-warning"
                  data-bs-dismiss="modal"
                >
                  ذخیره
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Delete Button and modal */}
        <button
          type="button"
          className="btn btn-sm btn-danger rounded"
          data-bs-toggle="modal"
          data-bs-target="#userDeleteModal"
          onClick={() => handleDelete(item)}
        >
          <AiOutlineDelete />
        </button>
        <div
          className="modal fade"
          id="userDeleteModal"
          tabIndex="-1"
          aria-labelledby="userDeleteModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header" dir="rtl">
                <h1 className="modal-title fs-5" id="userDeleteModalLabel">
                  حذف یوزر
                </h1>
              </div>
              <div className="modal-body" dir="rtl">
                آیا مطمئن هستید که یوزر حذف شود؟
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  لغو
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={confirmDelete}
                  data-bs-dismiss="modal"
                >
                  حذف شود
                </button>
              </div>
            </div>
          </div>
        </div>
      </td>
    </tr>
  ));

  return (
    <>
      <nav className="navbar bg-body-tertiary">
        <div className="container-fluid">
          <span className="navbar-brand mb-0 h1">User management</span>
        </div>
      </nav>
      <div className="p-3">
        <p className="d-inline-flex gap-1">
          <button
            className="btn btn-success"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapseExample"
            aria-expanded="false"
            aria-controls="collapseExample"
          >
            ریکارد جدید <IoIosAdd />
          </button>
        </p>
        <div className="collapse" id="collapseExample">
          <div className="card card-body">
            <form onSubmit={handleSubmit}>
              <div className="form-group row g-3">
                <div className="col-lg-4">
                  <label htmlFor="username" className="form-label">
                    Username
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="username"
                    name="username"
                    value={userFormData.username}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="col-lg-4">
                  <label htmlFor="password" className="form-label">
                    Password
                  </label>
                  <input
                    type="password"
                    className="form-control"
                    id="password"
                    name="password"
                    value={userFormData.password}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="col-lg-3">
                  <label htmlFor="role" className="form-label">
                    Role
                  </label>
                  <select
                    id="role"
                    name="role"
                    className="form-select"
                    value={userFormData.role}
                    onChange={handleChange}
                    required
                  >
                    <option value="" disabled>
                      Select a Role
                    </option>
                    <option value="admin">Admin</option>
                    <option value="uploader">Uploader</option>
                  </select>
                </div>
              </div>

              <div className="my-4">
                <button type="submit" className="btn btn-primary">
                  Create user
                </button>
              </div>
            </form>
          </div>
        </div>
        <div className="bg-body p-3 rounded mt-3">
          <table className="table p-3">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Username</th>
                <th scope="col">Role</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>{usersList}</tbody>
          </table>
        </div>
        {showResponse && (
          <div
            className="toast position-fixed bg-success m-3 bottom-0 end-0 p-3 show"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            ref={(el) => {
              if (el) {
                const toast = new window.bootstrap.Toast(el);
                toast.show();
              }
            }}
          >
            <div className="d-flex">
              <div className="toast-body">{responseMessage}</div>
              <button
                type="button"
                className="btn-close me-2 m-auto"
                data-bs-dismiss="toast"
                aria-label="Close"
              ></button>
            </div>
          </div>
        )}
        {showError && (
          <div
            className="toast position-fixed bg-danger m-3 bottom-0 end-0 p-3 show"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            ref={(el) => {
              if (el) {
                const toast = new window.bootstrap.Toast(el);
                toast.show();
              }
            }}
          >
            <div className="d-flex">
              <div className="toast-body">{errorMessage}</div>
              <button
                type="button"
                className="btn-close me-2 m-auto"
                data-bs-dismiss="toast"
                aria-label="Close"
              ></button>
            </div>
          </div>
        )}
        {hasMore ? (
          <div className="text-center mt-5">
            <button
              type="button"
              className="btn btn-sm btn-secondary rounded"
              id="loadmore"
              onClick={() => loadMore()}
            >
              مطالب بیشتر
            </button>
          </div>
        ) : (
          <div className="mt-5 text-center">
            <small className="p-2 bg-secondary text-light rounded">
              پایان مطالب
            </small>
          </div>
        )}
        {isLoading && (
          <div className="d-flex justify-content-center">
            <div
              className="spinner-border primary-text-blue"
              dir="ltr"
              role="status"
            >
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
